<template>
  <section class="p-1">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">BNM RSP Report</div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-form ref="form" v-model="valid" class="px-2">
            <v-row class="px-2">
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.fromdate"
                  label="From Date"
                  :rules="FieldRequired('From Date')"
                  type="date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="filterList.todate"
                  type="date"
                  :rules="FieldRequired('To Date')"
                  label="To Date"
                  dense
                  outlined
                  class="rounded"
                >
                </v-text-field>
              </v-col>
              <v-btn
                depressed
                @click="getReportResults()"
                class="mr-2 mt-1"
                color="primary"
                small
                >Get Results
              </v-btn>
            </v-row>
          </v-form>
        </v-card>
      </v-card-text>
      <v-row class="ma-1 px-2 mt-2">
        <v-btn
          depressed
          @click="downloadExcelsheet"
          class="mt-1"
          color="primary"
          small
          ><v-icon small>mdi-file-excel-outline</v-icon>Export
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          placeholder="Type here to filter values."
          hide-details
          rounded
          outlined
          dense
          clearable
          class="mt-2"
        ></v-text-field>
      </v-row>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="userList"
        :search="search"
        :items-per-page="pageLimit"
        :loading="loaderOverlay"
        loading-text="Loading please wait...."
        no-data-text="No data available."
        item-key="Pin_Number"
        dense
        class="mt-3"
      >
      </v-data-table>
    </v-card>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import { FieldRequired } from "@/utils/validation.js";
import alerts from "@/mixins/alerts";
import reportingService from "@/services/ReportingService/reportingService.js";

export default {
  mixins: [alerts],
  name: "RSP Report",
  data: () => {
    return {
      FieldRequired,
      pageLimit: -1,
      headers: [],
      filterList: {
        datetype: "",
        fromdate: new Date().toISOString().substr(0, 10),
        todate: new Date().toISOString().substr(0, 10),
        destinationagent: "",
        txnsstatus: "",
        paymenttype: "",
        sendingagentid: "",
      },
      userList: [],
      search: "",
      loaderOverlay: false,
      valid: false,
    };
  },
  computed: {
    ...mapGetters(["getpreviouspageState"]),
    isPreviousState() {
      return this.getpreviouspageState;
    },
  },

  methods: {
    async downloadExcelsheet() {
      if (this.userList) {
        this.exportToExcel(this.headers, this.userList, "userList");
      }
    },
    async getReportResults() {
      const validate = this.$refs.form.validate();
      if (validate) {
        this.loaderOverlay = true;
        try {
          const response = await reportingService.getrspReport(this.filterList);
          if (response.status === 200) {
            this.loaderOverlay = false;
            const ObjKeys = Object.keys(response.data.data[0]);
            this.headers = ObjKeys.map((ele) => {
              return {
                text: ele,
                value: ele,
                sortable: false,
              };
            });
            this.userList = response.data.data;
          } else {
            this.loaderOverlay = false;
          }
        } catch (error) {
          this.loaderOverlay = false;
          console.error(error);
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
.v-btn:not(.v-btn--round).v-size--default {
  height: 36px !important;
  min-width: 64px !important;
  padding: 0 16px !important;
}
.select-width {
  max-width: 60px;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
